module.exports = __webpack_public_path__ + "static/media/next-icon-light.881d7518.svg";